import { Component, NgZone } from '@angular/core';
import { AuthenticationService } from '../../../../../services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PersonalInterviewsService } from '../../../services/personal-interview.service';
import { ZoomMtg } from '@zoom/meetingsdk';

@Component({
  selector: 'app-zoom-meeting-view',
  templateUrl: './zoom-meeting-view.component.html',
  styles: ``
})
export class ZoomMeetingViewComponent {
  loading = true;
  loginUser: any;
  applicantId!: any;
  jobPostId!: any;
  zoomConfig: any;
  details!: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private service: PersonalInterviewsService,
    private ngZone: NgZone
  ) {
    this.loginUser = this.authenticationService.currentUserValue;
  }

  ngOnInit(): void {
    // loads WebAssembly assets
    ZoomMtg.preLoadWasm()
    ZoomMtg.prepareWebSDK()

    this.route.paramMap.subscribe(params => {
      this.applicantId = params.get('applicantId');
      this.jobPostId = params.get('jobPostId');
      let model = {
        post_job_id: this.jobPostId,
        applicant_id: this.applicantId
      }
      this.service.getInterviewEvaluationDetails(model).subscribe((res) => {
        this.loading = false;
        this.details = res.data;
        this.startMeeting();
      })
    });

  }


  startMeeting() {
    const self = this;
    this.ngZone.runOutsideAngular(() => {
      ZoomMtg.init({
        leaveUrl: '',
        patchJsMedia: true,
        leaveOnPageUnload: false,
        success: (success: any) => {
          ZoomMtg.join({
            signature: this.details?.zoom.signature,
            sdkKey: this.details?.zoom.client_id,
            meetingNumber: this.details?.zoom.meeting_number,
            passWord: this.details?.zoom.meeting_password,
            userName: this.loginUser.full_name,
            userEmail: this.loginUser.email,
            success: (success: any) => {

              // CASE 1 — Host ended meeting / kicked out / user left
              ZoomMtg.inMeetingServiceListener('onUserLeave', function (data: any) {
                console.log(data)
                if (data?.reasonCode == 1) {
                  self.endMeeting();
                }
                if (data?.reasonCode == 0 || data?.reasonCode == 2) {
                  self.endMeeting();
                }
              });

              // CASE 2 — Handle *any* Zoom popup (signature expired, timeout, errors, etc.)
              ZoomMtg.inMeetingServiceListener('onMeetingStatus', function (data: any) {

                // status codes: 1=ended, 3=disconnect, 5=failed, 7=reconnecting
                if ([1, 3, 5].includes(data.meetingStatus)) {
                  self.endMeeting();
                }
              });

            },
            error: (error: any) => {
              // CASE 3 — Join failed popup
              self.endMeeting();
            }
          });
        },
        error: (error: any) => {
          self.endMeeting();
        }
      });
    })
  }

  endMeeting() {
    localStorage.setItem('leaveMeeting', this.jobPostId.toString());
  }
}
